import { render, staticRenderFns } from "./team-leadership.vue?vue&type=template&id=7da89cab&scoped=true&"
import script from "./team-leadership.vue?vue&type=script&lang=js&"
export * from "./team-leadership.vue?vue&type=script&lang=js&"
import style0 from "./team-leadership.vue?vue&type=style&index=0&id=7da89cab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da89cab",
  null
  
)

export default component.exports